'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Action": "Polaris-Listbox-Action",
  "ActionDivider": "Polaris-Listbox-Action__ActionDivider",
  "Icon": "Polaris-Listbox-Action__Icon"
};

exports.default = styles;
